import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getCampianLanguages = async (user) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

    const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `/service/campaign_service/v1/campaign/template/meta/languages`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
    };
    const response = await axios.request(config);
    return response.data;
};

export default getCampianLanguages;
